import { useNewConversationFiltersStore } from "@/stores/new-conversation-filters.store";
import { DataSource } from "@/config/datasources";

/**
 * Hook to manage bidirectional sync of source selection between
 * SelectedContext and SourceSelectionDialog
 */
export const useSourceSelection = () => {
  const { filters, setFilters, removeFilter } =
    useNewConversationFiltersStore();

  /**
   * Get the currently selected source from the store
   */
  const getSelectedSource = (
    availableSources: DataSource[]
  ): DataSource | undefined => {
    const sourceKeys = Object.keys(filters);
    for (const sourceKey of sourceKeys) {
      if (availableSources.includes(sourceKey as DataSource)) {
        const sourceFilters = filters[sourceKey];
        if (sourceFilters && sourceFilters.length > 0) {
          return sourceKey as DataSource;
        }
      }
    }
    return undefined;
  };

  /**
   * Get filter values for a specific source
   */
  const getFilterValues = (
    source: DataSource
  ): Record<string, unknown> | undefined => {
    const sourceFilters = filters[source];
    if (sourceFilters && sourceFilters.length > 0) {
      return sourceFilters[0];
    }
    return undefined;
  };

  /**
   * Check if a source is currently selected
   */
  const isSourceSelected = (source: DataSource): boolean => {
    const sourceFilters = filters[source];
    return sourceFilters !== undefined && sourceFilters.length > 0;
  };

  return {
    getSelectedSource,
    getFilterValues,
    isSourceSelected,
    setFilters,
    removeFilter,
    filters,
  };
};
